"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var PartnersCtxItemImgNew = /** @class */ (function (_super) {
    __extends(PartnersCtxItemImgNew, _super);
    function PartnersCtxItemImgNew(props) {
        return _super.call(this, props) || this;
    }
    PartnersCtxItemImgNew.prototype.componentWillMount = function () {
        this.setState({
            bgColor: "#FFFFFF"
        });
    };
    PartnersCtxItemImgNew.prototype.onMouseEnter = function () {
        this.setState({
            bgColor: "#89CFF0"
        });
    };
    PartnersCtxItemImgNew.prototype.onMouseLeave = function () {
        this.setState({
            bgColor: "#FFFFFF"
        });
    };
    PartnersCtxItemImgNew.prototype.buttonClick = function () {
        console.log('new button click');
        if (this.props.onNewClick) {
            this.props.onNewClick(this.props.brandId);
        }
    };
    PartnersCtxItemImgNew.prototype.render = function () {
        var cssStyle = {
            borderColor: "black",
            borderStyle: "solid",
            borderLeftWidth: "1px",
            borderTopWidth: "1px",
            borderRightWidth: "1px",
            borderBottomWidth: "1px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "160px",
            height: "160px",
            marginLeft: "5px",
            marginTop: "5px",
            marginRight: "0px",
            marginBottom: "5px",
            backgroundColor: this.state.bgColor,
            cursor: "pointer",
            position: "relative"
        };
        return (React.createElement("div", { style: cssStyle, onMouseEnter: this.onMouseEnter.bind(this), onMouseLeave: this.onMouseLeave.bind(this), onClick: this.buttonClick.bind(this) },
            React.createElement(antd_1.Icon, { type: "upload", style: { fontSize: "42px" } }),
            React.createElement("div", { style: { overflow: "hidden", textOverflow: "ellipsis" } }, this.props.title)));
    };
    return PartnersCtxItemImgNew;
}(React.Component));
exports.default = PartnersCtxItemImgNew;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_images/ui/component/controls/PrtnersCtxItemImgNew.tsx
// module id = 2464
// module chunks = 0